<template>
  <div id="sign-success">
      <img class="logo" src="@/assets/fixed-invitation/logo.png" alt="">
      <h1 class="logo-name">金果子</h1>
      <h1>恭喜您注册成功!</h1>
      <div class="down-btn" @click="goDown">
          下载APP
          <!-- <img class="gift" src="@/assets/srx/sign/gift.png" alt=""> -->
      </div>
  </div>
</template>

<script>
export default {
    name: 'SignSuccess',
    data() {
        
    },
    methods: {
        goDown() {
            window.open(window.location.protocol + "//" + window.location.host)
        }
    }
}
</script>

<style lang='less'>
#sign-success {
    height: 100vh;
    position: relative;
    background: #ffffff;
    padding: 100px 30px 0 30px;
    .logo {
        height: 200px;
        width: 200px;
        margin-bottom: 20px;
    }
    .logo-name {
        font-size: 50px;
        font-weight: bold;
    }
    h1 {
        line-height: 36px;
        font-size: 50px;
        margin-bottom: 80px;
    }
    .down-btn {
        height: 88px;
        width: 690px;
        border-radius: 8px;
        line-height: 88px;
        background: #FFA41F;
        font-size: 34px;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        margin-bottom: 30px;
    }
    .tip {
        color: #EB4236;
        font-size: 28px;
    }
}
</style>